import { create } from 'zustand';

export const useSectionScroll = create((set, get) => ({
  scrollPct: -1,

  scrollTo: (scrollPct) => set({ scrollPct }),
  resetScrollTo: () => set({ scrollPct: -1 }),
}));
